<script setup>
import { useNuxtApp } from '#app';
import { useI18n } from 'vue-i18n';
import { useUsersStore } from '@/stores/users';
import loadingImage from '/public/images/lottie_files/finger-heart.json';
import axios from 'axios';

const { locale } = useI18n();
const nuxtApp = useNuxtApp();
const router = useRouter();

// Variable reactiva para manejar el estado de carga
const isLoading = ref(false);

function hideLoading() {
    setTimeout(() => {
        // console.log("hideLoading...");
        isLoading.value = false; // Ocultar preloader
    }, 500); // Añade un pequeño retraso para suavizar la transición
}

function showLoading() {
    // console.log("showLoading...");
    isLoading.value = true; // Mostrar preloader
}

// Hook para eventos del enrutador
nuxtApp.hook('page:loading:start', () => {
    // console.log('page:loading:start');
    showLoading();
});

nuxtApp.hook('page:loading:end', () => {
    // console.log('page:loading:end');
    hideLoading();
});

nuxtApp.hook('page:finish', () => {
    // console.log('page:finish');
    hideLoading();
});

// Hooks del Router
router.beforeEach((to, from, next) => {
    // console.log('Route change started');
    showLoading();
    next();
});

router.afterEach(() => {
    // console.log('Route change finished');
    hideLoading();
});

// Integración con Axios
axios.interceptors.request.use((config) => {
    // console.log('Axios request started');
    showLoading();
    return config;
}, (error) => {
    hideLoading();
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    // console.log('Axios response received');
    hideLoading();
    return response;
}, (error) => {
    hideLoading();
    return Promise.reject(error);
});

// Configuración inicial
onMounted(() => {
    // console.log('mounted');
    const savedLanguage = useUsersStore().language;
    if (savedLanguage) {
        locale.value = savedLanguage;
    }
    hideLoading(); // Asegúrate de ocultar el preloader al montar
});
</script>

<template>
    <!-- Preloader -->
    <!--<div
        :class="{
            hidden: !isLoading,
        }"
        class="fixed top-0 left-0 right-0 bottom-0 d-flex flex-column text-center h-screen align-center justify-center bg-white transition-opacity duration-500"
        style="z-index: 9999; opacity: 1; background-color: rgba(var(--v-theme-containerBg), 0.7) !important; backdrop-filter: blur(8px) !important;"
    >
        <div class="bg-grey100 rounded rounded-circle pa-1" style="width: 200px; height: 200px;">
            <Vue3Lottie :animationData="loadingImage" width="100%" class="d-block" />
            <h4 class="text-h4 font-weight-normal pt-8">{{ $t('basic.pleaseWait') }}</h4>
        </div>
    </div>
    -->
    <div :class="{
            hidden: !isLoading,
        }" class="fixed top-0 left-0 right-0 bottom-0 d-flex flex-column text-center h-screen align-center justify-center bg-white"
        style="position: fixed; z-index: 9999; opacity: 1; transition: opacity 0.5s ease; background-color: rgba(var(--v-theme-containerBg), 0.7) !important; backdrop-filter: blur(8px) !important; "
        >
            <div class="bg-lightprimary rounded rounded-circle pa-1" style="width: 200px; height: 200px;">
            <Vue3Lottie :animationData="loadingImage" width="100%" class="d-block" />
            <h4 class="text-h4 font-weight-normal pt-8">{{ $t('basic.pleaseWait')}}</h4>
            </div>
        </div>

    <ClientOnly>
        <VitePwaManifest />
    </ClientOnly>
    <NuxtLoadingIndicator color="primary" :height="4" />
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<style lang="css">
.hidden {
    opacity: 0 !important;
    pointer-events: none;
}
</style>
